export const optionsTemplates = [
    {
        name: 'Si, No, N/A',
        options: [
            'Si',
            'No',
            {
                text: 'N/A',
                isNA: true,
            }
        ]
    },
    {
        name: 'Listados de Operarios',
        options: [
            'ALBERTO TOMAS HERNANDEZ GARCIA',
            'ALEJANDRO JORGE AFONSO',
            'ANTONIO BAUER RAMOS',
            'CARLOS IVAN GORRIN MARTIN',
            'CUINTI JOSE PLASENCIA ALVAREZ',
            'EDUARDO HERNANDEZ ALONSO',
            'FLORENTINO RODRIGUEZ REYES',
            'FRANCISCO ADELTO FELIPE MARTIN',
            'GERMAN PEREZ GARCIA',
            'HILARIO M AYUT BETHENCOURT',
            'JAIVER HENRY MEDINA RICO',
            'JAMIN PEREZ CAMACHO',
            'JAVIER RIVEROL DE LAS CASAS',
            'JESUS GARCIA LORENZO',
            'JONATHAN MARTIN PEREZ',
            'JORGE DAVID RODRIGUEZ PEREZ',
            'JOSE GALIFER MARTIN PEREZ',
            'JOSE JAVIER VIÑA PEREZ',
            'JOSE MARIA RUIZ AVERO',
            'JUAN CARLOS BARRIOS GONZALEZ',
            'MANUEL JESUS PEREZ RODRIGUEZ',
            'MANUEL PEREZ MARRERO',
            'NORBERTO PEREZ PEREZ',
            'OLIVER BONILLA LUIS',
            'ROBERTO PABLO FELIPE BARROSO',
            'SERGIO RODRIGUEZ CONCEPCION',
            'SERVANDO ELADIO PEREZ RODRIGUEZ',
            'TOMAS FELIPE AFONSO'
        ]
    },
    {
        name: 'Vehículos',
        options: [
            'CITROEN BERLINGO HDI-75 5998-GPJ',
            'CITROEN BERLINGO HDI-75 0748-HCV',
            'FORD FIESTA 9401-JJN',
            'FORD TRANSIT 1254-GVT',
            'FORD TRANSIT 9643-CYT',
            'KIA PICANTO 7016-DVW',
            'MINICARGADORA E-3734-BBC',
            'NISSAN CABSTAR 125 3427-DLH',
            'NISSAN CABSTAR F24 9600-FXZ',
            'NISSAN CABSTAR F24 3248-GLS',
            'RENAULT CLIO 6295-HWB',
            'RENAULT KANGOO 6150-FPX',
            'RENAULT M250 TF-2857-BZ',
            'TOYOTA DYNA-100 TF-4496-BL',
            'TOYOTA DYNA-100 8558-BSP',
            'TOYOTA DYNA-150 TF-8316-BX',
            'TOYOTA HIACE 8386-DGX',
            'TOYOTA HIACE 5770-DTG',
            'TOYOTA HIACE 6058-FRS',
            'TOYOTA HILUX TF-9487-BV',
            'TOYOTA HILUX TF-2867-BW',
            'TOYOTA PROACE L1 1.6D 9980-KJH',
            'TOYOTA PROACE L1 1.6D 7490-LHB',
            'TOYOTA PROACE L1 1.6D 8728-LGX',
            'TOYOTA PROACE L1 1.6D 0733-KVN',
            'TOYOTA PROACE N 11.06N (EV) 5420-LRW',
            'VOLKSWAGEN TF-5183-BY',
            'VOLKSWAGEN 5981-DSP'
        ]
    }
];
